import {
  bulkType,
  NoImage,
  pageViewList,
  TestImage,
} from "@assets/constant/index.constant";
import { Clock, PlayButton } from "@assets/icons";
import { Badge } from "@components/ui/badge";
import { Button } from "@components/ui/button";
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from "@components/ui/carousel";
import { Checkbox } from "@ui/external/components/checkbox";
import Tooltip from "@ui/external/components/tooltip";
import PaginationFooter from "@ui/internal/components/pagination";
import {
  getTableInfo,
  isFn,
  isNullCheck,
  showToast,
} from "@utils/helper/index.helper";
import { Copy, Star } from "lucide-react";
import React, { useMemo } from "react";

import { cn } from "@/lib/utils";
import { Spinner } from "@components/ui/spinner";
import { Switch } from "@components/ui/switch";
import Dialog from "@ui/external/components/dialog";
import {
  GridCardSkeleton,
  TableSkeleton,
} from "@ui/external/components/skeleton";
import { useHandleAction, usePathname } from "@utils/hook/index.hook";
import { usePreviewVideo, useSelectionStore } from "@utils/states/index.state";
import { formatDistance } from "date-fns";
import { useNavigate, useParams } from "react-router";
import Empty from "../empty";
import { SortableTable, TableHeader } from "../table";
import {
  Drawer,
  DrawerClose,
  DrawerContent,
  DrawerDescription,
  DrawerFooter,
  DrawerHeader,
  DrawerOverlay,
  DrawerTitle,
} from "@components/ui/drawer";
import { ZoomImage } from "../formelement";
import { Skeleton } from "@components/ui/skeleton";
type Props = {
  type?: "moments" | "faq" | "forms" | "" | string;
  content?: BlogProps;
  tag?: string | string[];
  [key: string]: any;
};
interface VideoProps extends Props {
  isChecked?: boolean;
  showCheck?: boolean;
  subtitle?: string;
  [key: string]: any;
}
interface MentorProps extends VideoProps {
  images?: string[] | number | bigint | true | object | undefined;
  [key: string]: any;
}

interface MomentProps {
  image: string | number | bigint | true | object | undefined;
  [key: string]: any;
}

interface BlogProps {
  title?: string;
  date?: string;
  description?: string;
  tags?: string | string[];
  username?: string;
  userimage?: string;
  userdesignation?: string;
  image?: string;
  images?: string[];
  subtitle?: string;
  [key: string]: any;
}

interface UserProps {
  username?: string;
  userimage?: string;
  userdesignation?: string;
  [key: string]: any;
}

interface ActionProps {
  onEdit?: () => void;
  onDelete?: () => void;
  onCancel?: () => void;
  onToggleStatus?: (id: string, state: boolean) => void;
  [key: string]: any;
}
interface TableCardProps {
  table_content: {
    mode: "default" | "add" | "edit";
    type: string;
  };
  tableHeaderData?: any;
  showOrientationSecond?: boolean;
  isOrientation?: boolean;
  formId?: string;
  showOrientation?: boolean;

  orientationPosition?: "up" | "down" | boolean;
  inject_ui_table_actions?: React.ReactNode;
  /* extra controls rendered next to Clear/Delete while rows are selected */
  inject_bulk_actions?: React.ReactNode;
  bulkActions?: boolean;
  grid?: React.ReactNode;
  form?: React.ReactElement;
  columns: any[];
  count?: number;
  rows: any[];
  isPending?: boolean;
  endpoint?: string;
  className?: string;
  sortableFilter?: object;
  refetch?: () => void;
  hideSort?: boolean;
}
const GeneralCard: React.FC<Props & VideoProps & ActionProps> = ({
  content,
  description = "",
  isChecked = false,
  showCheck = false,
  type = "",
  onDelete,
  onEdit,
  onToggleStatus,
  ...props
}) => {
  const getPropsData = useMemo(() => {
    switch (type) {
      case "journey":
        return {
          image: isNullCheck(props?.item?.image),
          id: isNullCheck(props?.item?.id),
          title: isNullCheck(props?.item?.title),
          tags: isNullCheck(props?.item?.section),
        };
      case "success-stories":
        return {
          image: isNullCheck(props?.item?.featured_image),
          id: isNullCheck(props?.item?.id),
          title: isNullCheck(props?.item?.title),
        };
      case "moments":
        return {
          id: isNullCheck(props?.item?.id),
          image: isNullCheck(props?.item?.thumbnail),
          title: isNullCheck(props?.item?.title),
          video: isNullCheck(props?.item?.video),
        };
      case "industry":
        return {
          image: isNullCheck(props?.item?.image),
          id: isNullCheck(props?.item?.id),
          title: isNullCheck(props?.item?.name),
        };

      case "mentor":
        return {
          images: [
            isNullCheck(props?.item?.image),
            isNullCheck(props?.item?.doodle_image),
          ],
          id: isNullCheck(props?.item?.id),
          title: isNullCheck(props?.item?.user?.full_name),
          subtitle: isNullCheck(props?.item?.user?.full_name),
        };
      case "faq":
        return {
          id: isNullCheck(props?.item?.id),
          title: isNullCheck(props?.item?.question),
          description: isNullCheck(props?.item?.description),
        };
      case "career":
        return {
          id: isNullCheck(props?.item?.id),

          slug: isNullCheck(props?.item?.slug),
          isChecked: props?.item?.is_show,

          description: isNullCheck(props?.item?.description),
          content: {
            username: isNullCheck(props?.item?.title),
            description: isNullCheck(props?.item?.description),
            tags: isNullCheck(props?.item?.experience_level?.level_name),
            link: isNullCheck(props?.item?.apply_link),
            slug: isNullCheck(props?.item?.slug),
            userimage: isNullCheck(props?.item?.image),
            expiresIn: props?.item?.expiration_date,
          },
        };
      case "testimonial":
        return {
          title: isNullCheck(props?.item?.name),
          id: isNullCheck(props?.item?.id),
          image: isNullCheck(props?.item?.image),
          isChecked: props?.item?.is_show,
          video: isNullCheck(props?.item?.video),
          testimonial_type: isNullCheck(props?.item?.testimonial_type),
          description: isNullCheck(props?.item?.description),
          content: {
            username: isNullCheck(props?.item?.name),
            userimage: isNullCheck(props?.item?.image),
            userdesignation: isNullCheck(props?.item?.role),
          },
        };
      case "course":
        return {
          id: isNullCheck(props?.item?.id),
          isChecked: props?.item?.is_show,
          title: isNullCheck(props?.item?.title),
          image: isNullCheck(props?.item?.feature_image),

          content: {
            image: isNullCheck(props?.item?.feature_image),
            tags: [
              isNullCheck(props?.item?.categories.map((e: any) => e.name)),
            ],
            subtitle: isNullCheck(props?.item?.excerpt),
          },
        };
      case "branding": {
        return {
          title: isNullCheck(props?.item?.title),
          image: isNullCheck(props?.item?.image),
          id: isNullCheck(props?.item?.id),
        };
      }
      case "blog": {
        return {
          id: isNullCheck(props?.item?.id),
          title: isNullCheck(props?.item?.title),
          slug: isNullCheck(props?.item?.slug),
          description: isNullCheck(props?.item?.excerpt),
          content: {
            tags: isNullCheck(
              props?.item?.tags?.map(
                (item: { name: string; id: number }) => item.name,
              ),
            ),
            subtitle: isNullCheck(props?.item?.excerpt),
            userimage: isNullCheck(props?.item?.user?.professional_image),
            username: isNullCheck(props?.item?.author),
            image: isNullCheck(props?.item?.featured_image),
          },
        };
      }
      case "template":
        return {
          id: isNullCheck(props?.item?.id),
          title: isNullCheck(props?.item?.title || props?.item?.name),
          content: {
            description: isNullCheck(props?.item?.html_content),
          },
        };
      case "forms":
        return {
          title: isNullCheck(props?.item?.title),
          id: isNullCheck(props?.item?.id),

          content: {
            image: isNullCheck(props?.item?.media),
          },
          isChecked: props?.item?.is_show,
          expiresIn: isNullCheck(props?.item?.auto_expiration_date),
          description: isNullCheck(props?.item?.description),
        };

      case "teammember":
        return {
          title: isNullCheck(props?.item?.full_name),
          id: isNullCheck(props?.item?.id),
          content: {
            username: isNullCheck(props?.item?.full_name),
            image: isNullCheck(props?.item?.image),
            subtitle: isNullCheck(props?.item?.designation?.name),
            is_superuser: props?.item?.is_superuser,
          },
        };

      default:
        return {
          image: TestImage,
          title: "Certificate Template 1",
          tags: ["Clarity"],
        };
    }
  }, [props?.item]);
  const { handleAction } = useHandleAction({});
  const pathname = usePathname();
  const navigate = useNavigate();
  return (
    <>
      {/* w-[318px]  */}
      <div
        className={`border group border-[#E8F6F1] rounded-[20px] group transition-all  w-full overflow-hidden
          break-words 
      ${
        ["testimonial"].includes(type) && !description
          ? " h-fit max-h-[400px] "
          : type === "testimonial"
            ? "min-h-[100px] h-fit max-h-[400px] "
            : "h-fit"
      }
      ${props.className} `}
        {...props}
      >
        <CardHeader
          type={type}
          id={getPropsData.id}
          title={getPropsData.title}
          tag={getPropsData.tags}
          content={getPropsData.content}
          isChecked={getPropsData?.isChecked || isChecked}
          showCheck={showCheck}
          subtitle={getPropsData?.content?.subtitle}
          onToggleStatus={onToggleStatus}
        />
        <div className="min-h-[100px] h-full rounded-full max-h-[320px]">
          {["faq"].includes(type) ? (
            <div
              className={`md:p-[20px] p-[10px] ${
                getPropsData?.title ? "!pt-0" : ""
              }`}
            >
              <p
                className="line-clamp-4"
                dangerouslySetInnerHTML={{
                  __html: `<div>${getPropsData?.description}</div>`,
                }}
              ></p>
            </div>
          ) : ["moments", "testimonial"].includes(type) ? (
            getPropsData?.description ? (
              <div
                className={`md:p-[20px]  p-[10px] ${
                  getPropsData?.title ? "!pt-0" : ""
                }`}
              >
                {getPropsData?.testimonial_type == "video" && (
                  <MomentsBody
                    video={getPropsData?.video}
                    description={getPropsData?.description}
                    className={props.imageClass}
                    image={getPropsData?.image || NoImage}
                    type={type}
                  />
                )}
                {getPropsData?.testimonial_type !== "video" && (
                  <div className={`h-[220px]`}>
                    <p
                      className="line-clamp-4"
                      dangerouslySetInnerHTML={{
                        __html: getPropsData?.description as string,
                      }}
                    ></p>
                  </div>
                )}
              </div>
            ) : (
              <>
                <MomentsBody
                  video={getPropsData?.video}
                  description={getPropsData?.description}
                  className={props.imageClass}
                  image={getPropsData?.image || NoImage}
                  type={type}
                />
              </>
            )
          ) : type === "mentor" ? (
            <MentorCard type={type} images={getPropsData?.images ?? []} />
          ) : type === "blog" ? (
            <BlogBody
              content={getPropsData?.content}
              type={type}
              image={
                typeof getPropsData?.content?.image === "string"
                  ? getPropsData?.content?.image
                  : undefined
              }
            />
          ) : type === "forms" || type === "course" ? (
            <FormsBody
              content={getPropsData.content}
              type={type}
              image={
                typeof getPropsData?.content?.image === "string"
                  ? getPropsData?.content?.image
                  : undefined
              }
            />
          ) : type === "career" ? (
            <CareerBody
              content={getPropsData?.content}
              type={type}
              image={content?.image}
            />
          ) : type === "template" ? (
            <TemplateBody
              content={getPropsData?.content}
              type={type}
              image={content?.image}
            />
          ) : (
            <div
              className={`aspect-[16/9] w-full rounded-tl-[10px] rounded-tr-[10px] overflow-hidden h-[312px] relative`}
            >
              <img
                src={
                  typeof getPropsData?.image === "string"
                    ? (getPropsData?.image as string)
                    : getPropsData?.content?.image
                      ? (getPropsData?.content?.image as string)
                      : NoImage
                }
                alt="image"
                onError={(e: any) => {
                  const target = e.target as HTMLImageElement;
                  target.onerror = null;
                  target.src = NoImage;
                }}
                className="h-full w-full object-cover object-top"
              />
            </div>
          )}
        </div>

        <ActionButton
          onEdit={() => {
            ["blogs", "blogsC"].includes(pathname)
              ? navigate(
                  `/${
                    pathname === "blogs" ? "add-blogs" : "add-blogsC"
                  }?page=edit&page-item=${getPropsData.slug}`,
                )
              : handleAction({
                  type: pageViewList.includes(pathname)
                    ? "page-edit"
                    : "modal-edit",
                  data: type == "career" ? getPropsData.slug : getPropsData.id,
                });
          }}
          onDelete={() =>
            handleAction({
              type: "confirm",
              data: {
                type: "delete",
                id:
                  type === "career" || type === "blog"
                    ? getPropsData.slug
                    : getPropsData.id,
              },
            })
          }
        />
      </div>
    </>
  );
};

const MentorCard: React.FC<MentorProps> = ({ images = [NoImage] }) => {
  return (
    <>
      <div
        className={`aspect-[16/9] w-full rounded-tl-[10px] rounded-tr-[10px] overflow-hidden h-[312px] relative`}
      >
        {Array.isArray(images) && images?.length > 1 ? (
          <Carousel>
            <CarouselContent className="h-[320px]">
              {images?.map((item: string, index: number) => (
                <CarouselItem key={index} className="">
                  <img
                    src={item}
                    alt="image"
                    onError={(e: any) => {
                      const target = e.target as HTMLImageElement;
                      target.onerror = null;
                      target.src = NoImage;
                    }}
                    className="h-full w-full object-cover object-top"
                  />
                </CarouselItem>
              ))}
            </CarouselContent>
            <CarouselPrevious className="!left-[3%] shadow-lg" />
            <CarouselNext className="!left-[85%] shadow-lg" />
          </Carousel>
        ) : (
          <img
            src={
              (Array.isArray(images) && images?.length > 0
                ? images[0]
                : NoImage) as string
            }
            alt="image"
            className="h-full w-full object-cover object-top"
          />
        )}

        <div className="absolute top-[45%] w-full"></div>
      </div>
    </>
  );
};

const CardHeader: React.FC<ActionProps> = ({
  id = null,
  type = "",
  title,
  content,
  tag,
  showCheck,
  isChecked,
  onToggleStatus,
  subtitle,
}) => {
  const { selectedRows, setSelectedRows } = useSelectionStore();
  const handleCheck = (id?: string | number) => {
    let selection: number[] = [];
    if (typeof id === "undefined") return;
    selection =
      id && typeof id === "number" && selectedRows.includes(id)
        ? (selectedRows.filter((i) => i !== id) as number[])
        : ([...selectedRows, id] as number[]);
    setSelectedRows(selection as any[]);
    // setSelectedRowDetails(selection.length ? [content] : []);
  };

  return (
    <>
      {["testimonial", "blog", "teammember"].includes(type) ? (
        <div className=" px-[20px] pt-[25px] pb-[11px] flex items-center justify-between">
          <div className="flex gap-2 items-center">
            <Checkbox
              subtitle={subtitle}
              className={cn([
                `line-clamp-2 group-hover:translate-x-0 transition-all`,
                !selectedRows.includes(id) && "translate-x-[-38px]",
              ])}
              checked={selectedRows.includes(id) ? true : false}
              onCheckedChange={() => {
                handleCheck(id);
              }}
            />
            <UserProfile
              userdesignation={content?.userdesignation}
              userimage={content?.userimage}
              username={content?.username}
              className={cn([
                `group-hover:translate-x-0 transition-all`,
                !selectedRows.includes(id) && "translate-x-[-18px]",
              ])}
            />
          </div>
          {["blog"].includes(type) && (
            <button
              className={`h-[38px] w-[38px] border-[2px] rounded-full flex items-center justify-center cursor-pointer group hover:bg-[#ECECEC]`}
            >
              <Copy
                onClick={() => {
                  navigator.clipboard.writeText(
                    "https://skillshikshya.com/blog/" + content?.slug,
                  );
                  showToast({
                    title: "Copied to clipboard",
                    type: "success",
                    description: `Copied Link ${
                      "https://skillshikshya.com/blog/" + content?.slug
                    } `,
                  });
                }}
                className="group-hover:text-[#1DA077]"
                size={18}
              />
            </button>
          )}
          {showCheck && onToggleStatus && (
            <div className="">
              <Switch
                checked={isChecked}
                onCheckedChange={(e) => {
                  onToggleStatus?.(content?.id, e);
                }}
              />
            </div>
          )}
        </div>
      ) : ["forms"].includes(type) ? (
        <>
          <div className="px-[20px] pt-[25px] pb-[20px]">
            <div className="flex items-center justify-between w-full">
              <div className="flex gap-2 items-center">
                <Checkbox
                  subtitle={subtitle}
                  className={cn([
                    `line-clamp-2 group-hover:translate-x-0 transition-all`,
                    !selectedRows.includes(id) && "translate-x-[-38px]",
                  ])}
                  checked={selectedRows.includes(id) ? true : false}
                  onCheckedChange={() => {
                    handleCheck(id);
                  }}
                />

                <Tooltip description={content.title || title}>
                  <p className="text-[14px] font-[600] max-w-[210px] truncate">
                    {content.title || title}
                  </p>
                </Tooltip>
              </div>
              <div className="flex items-center cursor-pointer space-x-2">
                {content?.expiresIn && (
                  <Tooltip description={content?.expiresIn}>
                    <Clock />
                  </Tooltip>
                )}

                <Switch
                  checked={isChecked}
                  onCheckedChange={(e) => {
                    onToggleStatus?.(content?.id, e);
                  }}
                />
              </div>
            </div>
            {content.description && (
              <p
                className="text-[12px] line-clamp-3"
                dangerouslySetInnerHTML={{ __html: content?.description }}
              ></p>
            )}
          </div>
        </>
      ) : ["career"].includes(type) ? (
        <>
          <div className="px-[20px] pt-[25px] pb-[20px]">
            <div className="flex items-center justify-between w-full">
              <div className="flex items-center gap-2">
                <Checkbox
                  subtitle={subtitle}
                  className={cn([
                    `line-clamp-2 group-hover:translate-x-0 transition-all`,
                    !selectedRows.includes(id) && "translate-x-[-38px]",
                  ])}
                  checked={selectedRows.includes(id) ? true : false}
                  onCheckedChange={() => {
                    handleCheck(id);
                  }}
                />
                <UserProfile
                  userimage={content?.userimage}
                  userdesignation={content?.userdesignation}
                  username={content?.username}
                />
              </div>
              <div className="flex cursor-pointer items-center space-x-2">
                {content?.expiresIn && (
                  <Tooltip
                    description={formatDistance(Date.now(), content?.expiresIn)}
                  >
                    <span className="cursor-pointer">
                      <Clock />
                    </span>
                  </Tooltip>
                )}

                <Tooltip description={"Toggle Status"}>
                  <div>
                    <Switch
                      checked={isChecked}
                      onCheckedChange={(e) => {
                        onToggleStatus?.(content?.slug, e);
                      }}
                    />
                  </div>
                </Tooltip>
              </div>
            </div>
          </div>
        </>
      ) : ["template"].includes(type) ? (
        <>
          <div className="px-[20px] pt-[25px] pb-[20px]">
            <div className="flex items-center justify-between w-full">
              <p className="text-[20px] font-[600]">{title}</p>
            </div>
          </div>
        </>
      ) : ["teammember"].includes(type) ? (
        <>
          <div className="px-[20px] pt-[25px] pb-[20px]">
            <div className="flex items-center justify-between w-full">
              <div className="">
                <p className="text-[16px] font-[600] ">{title}</p>
                <p className="text-[16px] font-[400]">{subtitle}</p>
              </div>
              {content?.is_superuser && (
                <div className="">
                  <Star className="h-[20px] w-[20px] outline-1 rounded-full outline-offset-4 outline-yellow-400 text-yellow-400" />
                </div>
              )}
            </div>
          </div>
        </>
      ) : (
        <>
          {(title || tag) && (
            <div className="flex justify-between w-full items-center md:p-[20px] p-[10px]">
              {title && (
                <div
                  className={`font-[600] line-clamp-2  ${
                    ["faq"].includes(type) ? "" : ""
                  }`}
                >
                  {showCheck ? (
                    <div
                      className={cn([
                        `line-clamp-2 group-hover:translate-x-0 transition-all`,
                        !selectedRows?.includes(id) && "translate-x-[-18px]",
                      ])}
                    >
                      <Checkbox
                        label={title}
                        subtitle={subtitle}
                        className={`line-clamp-2`}
                        checked={selectedRows.includes(id) ? true : false}
                        onCheckedChange={() => {
                          handleCheck(id);
                        }}
                      />
                    </div>
                  ) : (
                    <div className="flex justify-between w-full gap-2">
                      <div className="w-full max-w-[250px] truncate ">
                        {title || content?.title}
                      </div>
                    </div>
                  )}{" "}
                  {subtitle && (
                    <div
                      dangerouslySetInnerHTML={{
                        __html: subtitle,
                      }}
                      className="text-[16px] font-[400] line-clamp-3 "
                    ></div>
                  )}{" "}
                </div>
              )}
              {tag && (
                <div>
                  <Tooltip key={tag} description={tag}>
                    <Badge
                      variant={"warning"}
                      key={tag}
                      className="max-w-[150px] w-fit truncate"
                    >
                      {tag}
                    </Badge>
                  </Tooltip>
                </div>
              )}
            </div>
          )}
        </>
      )}
    </>
  );
};

const ActionButton: React.FC<ActionProps> = ({ onEdit, onDelete }) => {
  return (
    <>
      {(isFn(onEdit) || isFn(onDelete)) && (
        <div className="flex">
          {isFn(onEdit) && (
            <button
              className="bg-[#E8F6F1] cursor-pointer text-[#1DA077] hover:bg-[#1DA077] hover:text-white h-[50px] w-full transition-all text-500"
              onClick={onEdit}
            >
              Edit
            </button>
          )}
          {isFn(onDelete) && (
            <button
              className="bg-[#F9EBEC] cursor-pointer text-[#C33241] hover:bg-[#C33241] hover:text-white h-[50px] w-full transition-all text-500"
              onClick={onDelete}
            >
              Delete
            </button>
          )}
        </div>
      )}
    </>
  );
};

const ActionConfirmButton: React.FC<ActionProps> = ({
  onCancel,
  onDelete,
  isPending = false,
}) => {
  return (
    <>
      {(isFn(onCancel) || isFn(onDelete)) && (
        <div className="flex gap-2 justify-end">
          {isFn(onCancel) && !isPending && (
            <Button variant={"outline"} onClick={onCancel}>
              No. Keep it
            </Button>
          )}
          {isFn(onDelete) && (
            <Button
              className={cn(isPending && "!cursor-not-allowed")}
              disabled={isPending}
              endIcon={isPending && <Spinner pathColor="#e6463d" />}
              variant={"destructive"}
              onClick={onDelete}
            >
              {isPending ? "processing..." : "Yes, Remove "}
            </Button>
          )}
        </div>
      )}
    </>
  );
};

const MomentsBody: React.FC<MomentProps> = ({ image, video, type }) => {
  const { setPreviewVideo } = usePreviewVideo();
  return (
    <>
      <div
        className={`aspect-[16/9] w-full rounded-tl-[10px] rounded-tr-[10px] overflow-hidden ${
          ["testimonial"].includes(type) ? "h-[220px]" : "h-[312px]"
        }  relative`}
      >
        <ZoomImage>
          <img
            src={image as string}
            alt="video-thumbnaiimage"
            onError={(e: any) => {
              const target = e.target as HTMLImageElement;
              target.onerror = null;
              target.src = NoImage;
            }}
            className="h-full w-full cursor-pointer object-cover object-top"
          />
        </ZoomImage>
        <img
          src={image as string}
          onClick={() => {
            if (video !== "N/A") {
              setPreviewVideo(video);
            }
          }}
          alt="video-thumbnaiimage"
          onError={(e: any) => {
            const target = e.target as HTMLImageElement;
            target.onerror = null;
            target.src = NoImage;
          }}
          className="h-full w-full cursor-pointer object-cover object-top"
        />
        {video !== "N/A" && (
          <div className="absolute top-[45%] w-full">
            <div className="w-full flex justify-center">
              <div className="relative h-[44px] w-[44px] rounded-full bg-white ">
                {/* Animated ring */}
                <span className="absolute inset-0 rounded-full border-2 border-[#1DA077] hidden group-hover:inline-block animate-ping" />

                {/* Second Ring with Delay */}
                <span className="absolute inset-0 rounded-full border-2 border-[#1DA077] hidden group-hover:inline-block animate-ping delay-200" />

                {/* Play button */}
                <div
                  onClick={() => {
                    if (video) {
                      setPreviewVideo(video);
                    }
                  }}
                  className="relative cursor-pointer z-10 mt-[6px] ms-[4px]"
                >
                  <PlayButton />
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

const BlogBody: React.FC<BlogProps> = ({ image = NoImage, content }) => {
  const { date, title, description, tags = [] } = content || {};
  return (
    <>
      <div className="aspect-[16/9] relative w-full rounded-tl-[10px] rounded-tr-[10px] overflow-hidden h-[210px]">
        <img
          src={image}
          alt=""
          className="h-full w-full object-cover object-top"
        />

        <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent z-[1]" />

        <div className="absolute top-0 w-full flex justify-end z-[2] p-[20px] space-x-2">
          {tags.length > 2 ? (
            <>
              {tags.slice(0, 2)?.map((item: string, index: number) => (
                <Tooltip key={index} description={item}>
                  <Badge
                    variant={"warning"}
                    key={index}
                    className="max-w-[150px] w-fit truncate"
                  >
                    {item}
                  </Badge>
                </Tooltip>
              ))}
              <Badge
                variant={"warning"}
                className="max-w-[150px] w-fit truncate"
              >
                +{content?.tags.length - 2}
              </Badge>
            </>
          ) : (
            tags?.map((item: string, index: number) => (
              <Tooltip key={index} description={item}>
                <Badge
                  variant={"warning"}
                  key={index}
                  className="max-w-[150px] w-fit truncate"
                >
                  {item}
                </Badge>
              </Tooltip>
            ))
          )}
        </div>

        {(title || description || date) && (
          <div className="absolute bottom-[20px] p-[20px] pb-0 z-[2]">
            {date && (
              <p className="text-white text-[12px]  max-w-[280px] truncate">
                {date}
              </p>
            )}
            {title && (
              <p className="text-white text-[14px] font-[600] max-w-[280px] truncate">
                {title}
              </p>
            )}
            {description && (
              <p className="text-white text-[12px] line-clamp-2">
                {description}
              </p>
            )}
          </div>
        )}
      </div>
    </>
  );
};

const TemplateBody: React.FC<BlogProps> = ({ content }) => {
  const { description } = content || {};

  return (
    <>
      <div className="relative w-full rounded-tl-[10px] rounded-tr-[10px] overflow-hidden h-[210px]">
        <p dangerouslySetInnerHTML={{ __html: description }}></p>
      </div>
    </>
  );
};

const FormsBody: React.FC<BlogProps> = ({ image = NoImage, content }) => {
  const { tags = [] } = content || {};
  return (
    <>
      <div className="aspect-[16/9] relative w-full  h-[312px]">
        <img
          src={image}
          alt="image"
          onError={(e: any) => {
            const target = e.target as HTMLImageElement;
            target.onerror = null;
            target.src = NoImage;
          }}
          className="h-full w-full object-cover object-top rounded-tl-[10px] rounded-tr-[10px]"
        />
        {image && (
          <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-black/20 z-[1] rounded-tl-[10px] rounded-tr-[10px]" />
        )}

        <div className="absolute top-[-10px] w-full flex px-[20px] justify-end z-[2] space-x-2">
          {tags.length > 2 ? (
            <>
              {tags.slice(0, 2)?.map((item: string, index: number) => (
                <Badge variant={"warning"} key={index}>
                  {item}
                </Badge>
              ))}
              <Badge variant={"warning"}>+2</Badge>
            </>
          ) : (
            tags?.map((item: string, index: number) => (
              <Badge variant={"warning"} key={index}>
                {item}
              </Badge>
            ))
          )}
        </div>
      </div>
    </>
  );
};

const CareerBody: React.FC<BlogProps> = ({
  image = NoImage,
  type,
  content,
  ...props
}) => {
  return (
    <>
      <div className="px-[20px] relative w-full h-[181px]" {...props}>
        <div className="flex justify-between items-center mb-[16px]">
          <div className=" w-full flex  z-[2] space-x-2">
            {Array.isArray(content?.tags) && content?.tags.length > 2 ? (
              <>
                {content?.tags
                  .slice(0, 2)
                  ?.map((item: string, index: number) => (
                    <Tooltip key={index} description={item}>
                      <Badge
                        variant={"warning"}
                        key={index}
                        className="max-w-[150px] w-fit truncate"
                      >
                        {item}
                      </Badge>
                    </Tooltip>
                  ))}{" "}
                <Badge
                  variant={"warning"}
                  className="max-w-[150px] w-fit truncate"
                >
                  +{content?.tags.length - 2}
                </Badge>
              </>
            ) : content?.tags ? (
              <Tooltip key={content?.tags} description={content?.tags}>
                <Badge
                  variant={"warning"}
                  key={content?.tags}
                  className="max-w-[150px] w-fit truncate"
                >
                  {content?.tags}
                </Badge>
              </Tooltip>
            ) : null}
          </div>
          <Tooltip description="Copy Link">
            <button
              onClick={() => {
                window.navigator.clipboard.writeText(content?.link);
                showToast({
                  description: "Link copied to clipboard",
                  title: "Success",
                  type: "success",
                });
              }}
              className={`h-[38px] min-w-[38px] border-[2px] rounded-full flex items-center justify-center cursor-pointer group hover:bg-[#ECECEC]`}
            >
              <Copy className="group-hover:text-[#1DA077]" size={18} />
            </button>
          </Tooltip>
        </div>

        {content.description && (
          <div className="">
            <p
              className="line-clamp-5"
              dangerouslySetInnerHTML={{
                __html: content.description,
              }}
            ></p>
          </div>
        )}
      </div>
    </>
  );
};

const UserProfile: React.FC<UserProps> = ({
  userdesignation,
  userimage,
  username,
  ...props
}) => {
  return (
    <>
      <div className={cn([`w-fit flex items-center group`, props.className])}>
        {userimage && (
          <img
            src={userimage}
            alt="image"
            onError={(e: any) => {
              const target = e.target as HTMLImageElement;
              target.onerror = null;
              target.src = NoImage;
            }}
            className="h-[40px] w-[40px] rounded-full object-cover object-top group-hover:outline-[#1DA077]/20 group-hover:outline-[3px]"
          />
        )}

        <ul className="ms-[10px]">
          {username && (
            // <li className="font-[600] max-w-[100px] truncate"> {username}</li>
            <Tooltip description={username}>
              <div className="flex justify-start text-gray-800">
                <span className="text-start w-fit max-w-[150px] truncate">
                  {username}
                </span>
              </div>
            </Tooltip>
          )}
          {userdesignation && (
            // <li className="max-w-[100px] truncate"> {userdesignation}</li>
            <Tooltip description={userdesignation}>
              <div className="flex justify-start text-gray-800">
                <span className="text-start w-fit max-w-[150px] truncate">
                  {userdesignation}
                </span>
              </div>
            </Tooltip>
          )}
        </ul>
      </div>
    </>
  );
};

const TablePreview: React.FC<any> = ({ image = NoImage, content = {} }) => {
  const { title, description } = content;
  return (
    <>
      <div className="flex items-center space-x-[10px]">
        <div className="imgBox w-[96px] h-[61px] rounded-[10px] overflow-hidden">
          <img src={image} className="h-full w-full object-cover" alt={title} />
        </div>
        {(title || description) && (
          <ul className="list-none max-w-[230px]">
            {title && (
              <li className="text-[14px] font-[600] line-clamp-1 ">{title}</li>
            )}
            {description && (
              <li className="text-[12px] line-clamp-2">{description}</li>
            )}
          </ul>
        )}
      </div>
    </>
  );
};

const TableCard: React.FC<TableCardProps> = ({
  grid,
  table_content,
  bulkActions = false,
  tableHeaderData = [],
  inject_ui_table_actions,
  inject_bulk_actions,
  orientationPosition = "up",
  form,
  columns = [],
  rows = [],
  count = 0,
  isPending,
  refetch,
  isOrientation,
  endpoint = "",
  formId,
  sortableFilter = {},
  className,
  hideSort = false,
  ...props
}) => {
  const {
    handleAction,
    searchParams,
    setSearchParams,
    deletePending,
    blukPending,
  } = useHandleAction({
    endpoint,
    refetch: refetch,
    bulktype: bulkType[`${endpoint}`],
  });
  const { type, id } = useParams();
  const pathname = usePathname();
  const { selectedRows, selectedRowDetails } = useSelectionStore();
  const { previewVideo, setPreviewVideo } = usePreviewVideo();
  const normalize = (str: string) =>
    str
      .toLowerCase()
      .replace(/[\s+]+/g, "-")
      .replace(/[^\w-]/g, "");

  const handleCategory = (item: number) => {
    ["courses", "masterclass-courses", "jrp-courses"].includes(pathname)
      ? searchParams.set(
          "data-category",
          `${tableHeaderData[item]["name"] ?? ""}`,
        )
      : searchParams.set(
          "data-category",
          `${tableHeaderData[item]["name"] ?? ""}`,
          // `${tableHeaderData[item]["name"]}-${
          //   tableHeaderData[item]["id"] ?? ""
          // }`
        );
    searchParams.set("page", "1");
    setSearchParams(searchParams);
  };
  const navigate = useNavigate();
  return (
    <>
      <div {...props}>
        <div className="sticky bg-white -top-2 z-20">
          <TableHeader
            className={cn(
              className,
              pathname == "students" && "lg:mt-30 lg:-translate-y-15",
            )}
            isGroupAction
            formId={formId}
            bulkActions={bulkActions}
            hideSort={hideSort}
            count={count}
            grid={grid}
            data={rows}
            inject_ui_table_actions={inject_ui_table_actions}
            inject_bulk_actions={inject_bulk_actions}
            content={{
              title: getTableInfo(table_content)?.title,
              description: getTableInfo(table_content)?.description,
            }}
            isOrientation={orientationPosition === "up"}
          />
        </div>

        {["add", "edit"].includes(searchParams.get("page") || "") ? (
          <div
            className={
              ["courses", "masterclass-courses", "jrp-courses"].includes(
                pathname,
              )
                ? "px-[20px] pb-[200px]"
                : "px-[20px] "
            }
          >
            {form}
          </div>
        ) : (
          <>
            {tableHeaderData &&
              ((Array.isArray(tableHeaderData) && tableHeaderData.length > 0) ||
                React.isValidElement(tableHeaderData)) && (
                <div className="p-4 px-[33px]">
                  <TableHeader
                    grid={grid}
                    data={rows}
                    count={count}
                    className={`${
                      pathname == "students"
                        ? "bg-none"
                        : "bg-[#FAFAFA]  h-24  py-[20px]"
                    } overflow-auto rounded-xl`}
                    content={{
                      title: "Skillshikshya Journey",
                      description:
                        "Add images to showcase the empowerment of learners at every step!",
                    }}
                    isOrientation={orientationPosition === "down"}
                    HeaderUiActions={inject_ui_table_actions}
                    hideSort={hideSort}
                  >
                    {Array.isArray(tableHeaderData) ? (
                      isPending ? (
                        <div className="flex items-center gap-6">
                          {Array(5)
                            .fill(0)
                            .map((_, i) => (
                              <div key={i} className="flex items-center gap-2">
                                <Skeleton className="h-4 w-12" />
                                <Skeleton className="h-4 w-6 rounded-full" />
                              </div>
                            ))}
                        </div>
                      ) : (
                        <div className="flex items-center overflow-auto w-full gap-[36px]">
                          {tableHeaderData.map((ti: any, tid: number) => {
                            // console.log("This is the ti", ti);
                            return (
                              <div
                                key={tid}
                                onClick={() => handleCategory(tid)}
                              >
                                <p className="font-medium flex items-center gap-2 cursor-pointer select-none">
                                  <span
                                    className={`capitalize text-nowrap overflow-auto hover:text-[#1aa178] ${
                                      // searchParams
                                      //   .get("data-category")
                                      //   ?.split("-")[0] === ti.name ||
                                      // searchParams.get("data-category") ===
                                      //   null && tid === 0
                                      //   ? "text-[#1aa178]"
                                      //   : ""
                                      normalize(
                                        searchParams.get("data-category") || "",
                                      ) === normalize(ti.name) ||
                                      (searchParams.get("data-category") ===
                                        null &&
                                        tid === 0)
                                        ? "text-[#1aa178]"
                                        : ""
                                    } `}
                                  >
                                    {ti.name}
                                  </span>{" "}
                                  <span className="text-[12px] block text-orange-400">
                                    {ti.count < 9 && ti.count > 0
                                      ? `0${ti.count}`
                                      : `${ti.count > 50 ? `50+` : ti.count}`}
                                  </span>
                                </p>
                              </div>
                            );
                          })}
                        </div>
                      )
                    ) : React.isValidElement(tableHeaderData) ? (
                      tableHeaderData
                    ) : (
                      <></>
                    )}
                  </TableHeader>
                </div>
              )}

            {isPending ? (
              <>
                {searchParams.get("orientation") == "grid" ? (
                  <GridCardSkeleton />
                ) : (
                  <TableSkeleton />
                )}
              </>
            ) : rows?.length > 0 ? (
              <>
                <div className={cn("py-[10px]  px-4", className)}>
                  {grid &&
                  ["grid"].includes(searchParams.get("orientation") || "") ? (
                    <div className="grid my-10 grid-cols-1 h-full sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-3 gap-y-[20px] gap-x-[20px]">
                      {rows?.map((item, index) =>
                        // @ts-ignore
                        React.cloneElement(grid, { key: index, item }),
                      )}
                    </div>
                  ) : (
                    <SortableTable
                      endpoint={endpoint}
                      refetch={refetch}
                      sortableFilter={sortableFilter}
                      columns={columns ?? []}
                      rows={rows ?? []}
                    />
                  )}
                </div>

                {!["drag"].includes(searchParams.get("orientation") || "") && (
                  <div className="my-4">
                    <PaginationFooter
                      action={() => {}}
                      total={count}
                      value={{
                        page: Number(searchParams.get("tpage")) || 1,
                        per: Number(searchParams.get("per")) || 10,
                      }}
                      showPerPage
                    />
                  </div>
                )}
                {searchParams.get("drawer") && (
                  <Drawer
                    open={searchParams.get("drawer") ? true : false}
                    onClose={() => {
                      handleAction({ type: "close" });
                    }}
                    direction="right"
                  >
                    <DrawerContent className="px-[20px] py-[20px] ">
                      <DrawerHeader>
                        <DrawerTitle className="font-bold text-[20px] text-[#363636]">
                          {" "}
                          {getTableInfo(table_content)?.title}
                        </DrawerTitle>
                        <DrawerDescription className="text-[14px] text-[#7e7e73]">
                          Manage all the details of{" "}
                          {getTableInfo(table_content)?.title}{" "}
                        </DrawerDescription>
                      </DrawerHeader>

                      <div className="w-full h-full p-3 overflow-y-auto">
                        {form}
                      </div>
                    </DrawerContent>
                    <DrawerOverlay />

                    <DrawerClose />
                    <DrawerFooter></DrawerFooter>
                    <DrawerClose />
                  </Drawer>
                )}
              </>
            ) : (
              <>
                <div className="flex gap-[20px] py-[50px]">
                  <Empty
                    position="center"
                    image="/assets/images/cameralooking.png"
                    title={getTableInfo(table_content)?.title}
                    description={getTableInfo(table_content)?.description}
                  >
                    {type == "masterclass-invoice" ||
                    type == "jrp-invoice" ||
                    type == "invoice" ? (
                      <Button
                        onClick={() => {
                          if (pathname === "blogs") {
                            navigate("/add-blogs");
                          } else {
                            handleAction({
                              type: pageViewList.includes(type || pathname)
                                ? "page-add"
                                : "modal-add",
                            });
                          }
                        }}
                        className="capitalize"
                      >
                        Add
                        {(searchParams.get("search") &&
                          `"${searchParams.get("search")}" in`) ||
                          ""}{" "}
                        {(type || pathname)?.replace(/-/g, " ")}
                      </Button>
                    ) : (
                      <></>
                    )}
                  </Empty>
                </div>
              </>
            )}
          </>
        )}
      </div>

      {(searchParams.get("modal") ||
        ["delete", "bulk", "bulk-edit"].includes(
          searchParams.get("confirm") || "",
        )) && (
        <>
          <Dialog
            className={cn([
              [
                "success-stories",
                "moments",
                "mentors",
                "payment",
                "masterclass-payment",
                "jrp-payment",
              ]?.includes(pathname) && !searchParams.get("confirm")
                ? ` ${
                    ["payment", "masterclass-payment", "jrp-payment"].includes(
                      pathname,
                    )
                      ? "lg:min-w-[900px]"
                      : "lg:min-w-[700px]"
                  } lg:max-w-auto max-w-[330px]`
                : "lg:min-w-[400px] lg:max-w-auto max-w-[330px]",
            ])}
            open={
              searchParams.get("modal") || searchParams.get("confirm")
                ? true
                : false
            }
            title={
              pathname === "response-enrollment" && !searchParams.get("confirm")
                ? "Convert to Student"
                : `${
                    searchParams.get("modal") ||
                    "Are you sure you want to remove"
                  } ${(id || type || pathname)?.replace(/-/g, " ")}${
                    searchParams.get("confirm") ? "?" : ""
                  }`
            }
            description={
              searchParams.get("confirm")
                ? `Selected ${(type || pathname)?.replace(
                    "-",
                    " ",
                  )} will be removed permanently. Do you want to remove it anyway?`
                : `Manage Skillshikshya ${(type || pathname)?.replace(
                    "-",
                    " ",
                  )} here.`
            }
            setOpen={() =>
              handleAction({
                type: searchParams.get("confirm")
                  ? "confirm-close"
                  : "modal-close",
              })
            }
          >
            <>
              {/* {JSON.stringify(selectedRowDetails)} */}
              {searchParams.get("confirm") || searchParams.get("bulk") ? (
                <>
                  {/* {JSON.stringify(selectedRowDetails)} */}
                  {!searchParams.get("page-item") &&
                    !searchParams.get("modal-item") &&
                    selectedRowDetails?.length > 0 && (
                      <div className="text-[14px]">
                        <span className="font-semibold">
                          The following items will be deleted permanently:
                        </span>
                        <span className="text-[14px] flex flex-wrap gap-1 ">
                          {selectedRowDetails
                            ?.slice(0, 5)
                            .map((item, index) => (
                              <span
                                key={item?.id}
                                className="truncate block max-w-[150px] w-fit"
                              >
                                {/* {JSON.stringify(selectedRowDetails)} */}
                                {item?.title ||
                                  item?.name ||
                                  item?.user?.full_name ||
                                  item?.question ||
                                  item?.full_name ||
                                  item?.username ||
                                  item?.invoice?.invoice_no ||
                                  "N/A"}
                                {index <
                                  selectedRowDetails.slice(0, 5).length - 1 &&
                                  ","}
                              </span>
                            ))}

                          {selectedRowDetails?.length > 5 && (
                            <> and +{selectedRowDetails?.length - 5} more</>
                          )}
                        </span>
                      </div>
                    )}
                  <ActionConfirmButton
                    isPending={deletePending || blukPending}
                    onDelete={() => {
                      searchParams.get("confirm") == "bulk-edit"
                        ? handleAction({
                            type: "bulk-edit",
                            data: ["bulk"].includes(
                              searchParams.get("confirm") || "",
                            )
                              ? selectedRows || []
                              : searchParams.get("confirm-item"),
                          })
                        : handleAction({
                            type: "delete",
                            data: ["bulk"].includes(
                              searchParams.get("confirm") || "",
                            )
                              ? selectedRows || []
                              : searchParams.get("confirm-item"),
                          });
                    }}
                    onCancel={() => {
                      handleAction({ type: "confirm-close" });
                    }}
                  />
                </>
              ) : (
                <div className="max-h-[80vh] overflow-y-auto">{form}</div>
              )}
            </>
          </Dialog>
        </>
      )}
      <Dialog
        className={cn([
          "bg-slate-100 shadow-none border-none",
          "min-w-[600px] max-h-[90vh]",
        ])}
        open={previewVideo.length > 0}
        setOpen={() => {
          setPreviewVideo("");
        }}
      >
        <video
          src={previewVideo}
          controls
          controlsList="nodownload"
          autoPlay
          className="w-full h-full max-h-[80vh] object-cover  cursor-pointer  rounded-md "
        />
      </Dialog>
    </>
  );
};

export {
  ActionButton,
  ActionConfirmButton,
  GeneralCard,
  TableCard,
  TablePreview,
  UserProfile,
};
